diy.angular.registerFactory('diyfmmessages', ['$q', '$timeout', 'diyfmselectiondata', 'diyfilevalidator', 'diyl10n', function($q, $timeout, diyfmselectiondata, diyfilevalidator, diyl10n) {

    var $ = jQuery;

    /**
     * shows a message in a DIY dialog. returns a promise which
     * resolves in case the user pressed the ok action and rejects in case
     * the user pressed the cancel action
     * @param opts
     *  - title: the message title
     *  - content: the message content
     *  - ok: if this key is present, an ok button with it's value as text will be added in the dialog's footer
     *  - cancel: if this key is present, a cancel button with it's value as text will be added in the dialog's footer
     *  - width: if this key is present, it will override the default width of the dialog
     * @returns {promise|a.fn.promise|Q.promise|.n.promise}
     */
    var showMessage = function(opts) {

        // close all previous dialogs that may have remained open
        jQuery('.fm-error-dialog').diy_confirmationDialog('destroy').remove();

        var deferred = $q.defer();

        var content = opts.content || "";
        if (opts.title) {
            var title = '<div class="confirmation-wrapper with-icon">\
                    <div class="confirmation-icon ui-icon ui-icon-alert"></div>\
                    <h2>' + opts.title + '</h2>\
                </div>';
            content = title + content;
        }

        var buttons = [];
        if (opts.ok) {
            buttons.push({
                text: opts.ok,
                click: function() {
                    $(this).diy_confirmationDialog('destroy').remove();
                    $timeout(function() {
                        deferred.resolve();
                    });
                }
            });
        }
        if (opts.cancel) {
            buttons.push({
                text: opts.cancel,
                click: function() {
                    $(this).diy_confirmationDialog('destroy').remove();
                    $timeout(function() {
                        deferred.reject();
                    });
                },
                'class': 'button-cancel'
            });
        }

        $("<div class='fm-error-dialog'>" + content + "</div>").diy_confirmationDialog({
            modal: true,
            width: opts.width || 320,
            buttons: buttons,
            draggable: false
        });

        return deferred.promise;
    };

    var sendToServer = function(msg) {
        jQuery(document).trigger("error.diy-editor", {"message": JSON.stringify(angular.extend(msg, {feature: 'File manager'}))})
    };

    var handleAddError = function(response) {
        /* if all have failed */
        if (response.allFailed) {
            sendToServer({
                action: 'allImagesFailedAdding',
                error: response.errors
            });
            return showMessage({
                title: diyl10n('filemanager.error.add.all'),
                content: content,
                ok: diyl10n('ok'),
                width: 520
            });
        } else {
            var content = diyl10n('filemanager.error.add.some').format({
                failedFilesCount: response.totalFilesFailed
            });
            return showMessage({
                title: content,
                ok: diyl10n('ok'),
                width: 520
            });
        }
    };

    var handleGenericError = function() {
        showMessage({
            title: diyl10n('filemanager.error.generic'),
            ok: diyl10n('ok')
        }).then(function() {
            diy.editor.filemanager.reload();
        });
    };

    var handleUploadError = function(report) {
        var content = '<div class="fm-deleteconfirmation">';
        content += '<table>';
        report.forEach(function(entry) {
            content += '<tr><td>' + $('<foo>').text(entry.file.name).html() + '</td><td>'  +  (entry.error.message ? entry.error.message : diyfilevalidator.getMessageByHttpErrorCode(entry.error.code)) + '</td></tr>';
        });
        content += '</table>';
        content += '</div>';

        return showMessage({
            title: diyl10n('filemanager.error.upload'),
            content: content,
            ok: diyl10n('cancel'),
            width: 520
        });
    };

    var showMessageItemsThumbs = function(opts) {
        opts.content = opts.content || "";
        opts.content += '<div class="fm-deleteconfirmation">';
        opts.content += '<ul>';
        opts.items.forEach(function(item) {
            opts.content += '<li><img src="' + item.getThumb() + '" /><span>'
                + $('<foo>').text(item.getName()).html() + '</span></li>';
        });
        opts.content += '</ul>';
        opts.content += '</div>';

        return showMessage(opts);
    };

    return {
        showMessage: showMessage,
        showMessageItemsThumbs: showMessageItemsThumbs,
        handleAddError: handleAddError,
        handleGenericError: handleGenericError,
        handleUploadError: handleUploadError
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/services/diyfmmessages.js
 ** module id = 942
 ** module chunks = 0
 **/